/**
 * API endpoint constants.
 * Centralized location for all API URLs used throughout the application.
 */

const API_BASE = '/api/v1';

export const AUTH = {
  BASE: `${API_BASE}/auth`,
  LOGIN: `${API_BASE}/auth/login`,
  LOGOUT: `${API_BASE}/auth/logout`,
  REGISTER: `${API_BASE}/auth/register`,
  REFRESH: `${API_BASE}/auth/refresh`,
} as const;

export const USER = {
  BASE: `${API_BASE}/user`,
  ME: `${API_BASE}/user/me`,
  CHECK: `${API_BASE}/user/check`,
  ONBOARDING: `${API_BASE}/user/onboard`,
  REGISTER: `${API_BASE}/user/register`,
  PROFILE: `${API_BASE}/user/profile`,
  RESET: `${API_BASE}/user/reset`,
  CONFIRMATION: `${API_BASE}/user/confirmation`,
  RESEND_CONFIRMATION: `${API_BASE}/user/resend`,
} as const;

export const LIVESET = {
  BASE: `${API_BASE}/liveset`,
  DETAILS: `${API_BASE}/liveset/details`,
  EVENT: `${API_BASE}/liveset/event`,
} as const;

export const TIDAL = {
  AUTH_BASE: `${API_BASE}/tidal/auth`,
  AUTH_STATUS: `${API_BASE}/tidal/auth/status`,
  AUTH_INITIATE: `${API_BASE}/tidal/auth/initiate`,
} as const;
